/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

/**
 * Define all the .env file related keys
 */
// eslint-disable-next-line prefer-destructuring
const env = import.meta.env;

const ENVIRONMENT = {
  BACKEND_API: env?.REACT_APP_BACKEND_API,
  APP_NAME: env?.REACT_APP_APP_NAME,
  PERSIST_ENCRYPTED_SECRET_KEY: env.REACT_APP_PERSIST_ENCRYPTED_SECRET_KEY,
  PERSIST_KEY: env.REACT_APP_PERSIST_KEY,
  PERSIST_VERSION: env.REACT_APP_PERSIST_VERSION,
  USER_INVITATION_EXPIRATION_MINUTES: env.REACT_APP_USER_INVITATION_EXPIRATION_MINUTES,
  KC_DOMAIN: env?.REACT_APP_KC_DOMAIN,
  APP_URL: env?.REACT_APP_URL,
  APP_LOGO: env.REACT_APP_LOGO,
  FAVICON: env.REACT_APP_FAVICON,
  AIRO_FAVICON: env.REACT_APP_AIRO_FAVICON,
  AIRO_APP_LOGO: env.REACT_APP_AIRO_LOGO,
  AIRO_APP_URL: env.REACT_APP_AIRO_URL,
  KC_AIRO_CLIENT_ID: env?.REACT_APP_AIRO_CLIENT_ID,
  KC_REALM: env?.REACT_APP_KC_REALM,
  KC_CLIENT_ID: env?.REACT_APP_CLIENT_ID,
  KC_PKCE_CHALLENGE_METHOD: env?.REACT_APP_KC_PKCE_CHALLENGE_METHOD,
  KC_PKCE_VERIFIER_LENGTH: parseInt(env?.REACT_APP_KC_PKCE_VERIFIER_LENGTH, 10),
  PBI_BASIC_SCHEMA: env.REACT_APP_PBI_BASIC_SCHEMA,
  PBI_ADVANCED_SCHEMA: env.REACT_APP_PBI_ADVANCED_SCHEMA,
  TIMEOUT_DELAY: env.REACT_APP_TIMEOUT_DELAY,
  REQUEST_TIMEOUT_MS: env?.REACT_APP_REQUEST_TIMEOUT_MS,
  ENABLE_SCENARIO_TAB: env.REACT_APP_ENABLE_SCENARIO_TAB,
};
//
export default ENVIRONMENT;
